import { useEffect } from 'react';
import { useAuth } from '@workos-inc/authkit-react';
import { useApiAuth } from '@/hooks/use-api-auth';
import { captureAttribution, syncAttribution } from '@/lib/attribution';

/**
 * AttributionTracker - captures first-touch attribution and syncs it once the
 * user is authenticated. Renders nothing.
 *
 * Mount inside AuthKitProvider (so it can read the WorkOS user) and inside
 * ApiAuthProvider (so the API token getter is initialized before we POST).
 */
export function AttributionTracker() {
  const { user } = useAuth();
  const { isAuthReady } = useApiAuth();

  // Capture on first load, before the user ever clicks sign up / sign in.
  useEffect(() => {
    captureAttribution();
  }, []);

  // Once authenticated and the API client is ready, persist it (once).
  useEffect(() => {
    if (isAuthReady && user) {
      void syncAttribution();
    }
  }, [isAuthReady, user]);

  return null;
}
